export default function TerminalLine(props) {
    return (
        <>
            <div className="terminal__prompt--line">
                <span id="terminal__prompt--user">page@terminal:</span>
                <span id="terminal__prompt--location">{props.dir}</span>
                <span id="terminal__prompt--bling">$</span>
                <span id="terminal__prompt--text">{props.line}</span>
            </div>
            <div>
                <span id="terminal__prompt--text">{props.response}</span>
            </div>
        </>
    )
}
